<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app">

		<router-view></router-view>

		<anchor-verify-email-alert v-if="auth.active === 0" position="bottom">
			<div>{{ $t('verifyEmail.pleaseVerifyEmail') }}
				<router-link class="text-white"
					:to="{ name: 'user-profile', params: { tab: 'general' } }"><b>{{ $t('verifyEmail.verifyEmail') }}</b>
				</router-link>
				{{ $t('verifyEmail.toUseAllFeatures') }}
			</div>
		</anchor-verify-email-alert>

		<modal-rating v-if="isMountModal && isRating" />
		<user-onboarding :off="true"></user-onboarding>
		<policy-modal />


		<vue-onboarding-step name="obd-dashboard" :step="getStepNumberBubbleChat()">
			<template v-slot="{ attributes }">
				<div class="bubble-chat-position messenger" v-bind="attributes">
					<the-zalo-chat />
				</div>
			</template>
		</vue-onboarding-step>

		<EkycRemind :isVisible.sync="showPopup" v-if="showPopup" />

	</div>
</template>

<script>
import themeConfig from '@/themeConfig.js'
import moment from 'moment/moment.js';
import AnchorVerifyEmailAlert from './components/Alert/AnchorVerifyEmailAlert.vue';
import ModalRating from './components/Rate/ModalRating.vue';
import UserOnboarding from './components/UserOnboarding/UserOnboarding.vue';
import scriptService from './core/services/scriptService';
import onboardingService from './core/services/onboardingService';
import authService from "./core/services/authService";
import zendeskService from "./core/services/zendeskService";
import Cookies from "js-cookie";
import PolicyModal from "./components/Policy/PolicyModal.vue";
import {LARGER, SMALLER} from "./store/modules/userCreatedDateModule";
import TheZaloChat from "./components/Chat/ZaloChat.vue";
import VueOnboardingStep from "./components/VueOnboarding/VueOnboardingStep.vue";
import userAgent from "./core/helpers/userAgent";
import { checkTabPathTitle } from './core/helpers/routeHelpers';
import EkycRemind from "./components/Popup/EkycRemind.vue";
import Vue from "vue";
export default {
	name: "app",

	components: {
		VueOnboardingStep,
		TheZaloChat,
		PolicyModal,
		AnchorVerifyEmailAlert,
		ModalRating,
		UserOnboarding,
		EkycRemind
	},

	data() {
		return {
			isMountModal: false,
			UI: {
				isMobileScreen: userAgent.isMobileResolution(525),
				isMobile: userAgent.isMobileResolution(),
			},
			ekycInterval: null,
			showPopup: false,
		}
	},

	computed: {
		auth() {
			return this.$auth.user();
		},
		isRating() {
			const isRating = this.$auth.user().isRating;
			return isRating;
		},

	},
	watch: {
    // auth(newAuth) {
    //   if (newAuth) {
    //     this.fetchEkycStatus();
    //   }
    // },
		'$store.state.theme'(val) {
			this.toggleClassInBody(val)
		},
		"$store.state.vueOnboarding.hasOnboarding"() {
			this.decisionMountModal();
		},
    '$route'(val) {

      switch (val.name) {
        case 'order-report':
          let startDate = localStorage.getItem('mo-order-start-date');
          let endDate = localStorage.getItem('mo-order-end-date');
          if (typeof startDate !== 'undefined' && startDate !== null && typeof endDate !== 'undefined' && endDate !== null) {
            val.query.startDate = startDate;
            val.query.endDate = endDate;
            localStorage.removeItem('mo-order-start-date');
            localStorage.removeItem('mo-order-end-date');
          }
          break;
        case 'order-report-detail':
          let newBreadCrumbReport = val.meta.breadcrumb.slice(0, 2);
          let dateParam = '';
          if (typeof val.query.startDate !== 'undefined' && typeof val.query.endDate !== 'undefined') {
            dateParam = '?startDate=' + val.query.startDate + '&endDate=' + val.query.endDate;
          } else {
            let date = moment().format('DD.MM.YYYY');
            dateParam = '?startDate=' + date + '&endDate=' + date;
          }
          newBreadCrumbReport.push(
            { title: 'Báo cáo đơn hàng', url: '/report/order' + dateParam }
          );
          newBreadCrumbReport.push(
            { title: val.params.offerID, active: true }
          );
          this.$route.meta.breadcrumb = newBreadCrumbReport;
          break;

        case 'knowledge-base-category':
        case 'knowledge-base-post':
          let newBreadCrumbKnow = val.meta.breadcrumb.slice(0, 2);
          this.$route.meta.breadcrumb = newBreadCrumbKnow;
          break;
        case 'user-profile':
          checkTabPathTitle(this.$route);
          break;

        case 'thank-you':
          gtag("event", "sign_up_end");
          Cookies.remove("time_sign_up");
          break;

        case 'offer':
          this.trackingCodeFindOffer('start')
          break;
        case 'page-login':
          this.showPopup = false
          break;

        default:
          if (val.name !== 'page-login') {
            this.checkUserDeactivated();
          }
          break;
      }
      if (val.path == '/user/profile/payment') {
        if (this.$auth.check()) {
          authService.getUser().then((userInfo) => {
            if (userInfo.is_company == 0 && !userInfo.is_ekyc) {
              this.showPopup = true
            }

          })
        }
      }
      this.$root.$emit('changeRoute', { name: val.name });
      this.trackingCodeFindOffer('end')

    }
	},
	methods: {
    fetchEkycStatus() {
      if (this.ekycInterval) return;
      if (this.$auth.check()) {
        authService.getUser().then((userInfo) => {
          if (userInfo.is_company == 0 && !userInfo.is_ekyc) {
            if (this.$route.path !== '/user/profile/info') {
              this.showPopup = true
            }
            this.intervalPopupEkyc();
          } else {
            this.showPopup = false;
            this.stopEkycInterval();
          }
        })
      }
    },

    intervalPopupEkyc() {
      if (!this.ekycInterval) {
        this.ekycInterval = setInterval(() => {
          if (this.$route.path !== '/user/profile/info') {
            this.showPopup = true
          }
        }, 30 * 60 * 1000);
      }
    },

    handleCheckEkycStatus() {
      this.showPopup = false;
      // this.stopEkycInterval();
    },
    stopEkycInterval() {
      if (this.ekycInterval) {
        console.log('stop interval');
        clearInterval(this.ekycInterval);
        this.ekycInterval = null;
      }
    },
		toggleClassInBody(className) {
			if (className == 'dark') {
				if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
				document.body.classList.add('theme-dark')
			} else if (className == 'semi-dark') {
				if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
				document.body.classList.add('theme-semi-dark')
			} else {
				if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
				if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
			}
		},
		handleWindowResize() {
			this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
		},
		handleScroll() {
			this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
		},
		trackingPubRegister: function () {
			var trackingParams = new URL(window.location.href).searchParams;

			if (trackingParams.has("utm_source")) {
				var source = trackingParams.get("utm_source");
				var campain = trackingParams.get("utm_camp");

				if (typeof source !== 'undefined' && source != '') {
					this.setCookie("utm_source", source, 30);
				}

				if (typeof campain !== 'undefined' && campain != '') {
					this.setCookie("utm_camp", campain, 30);
				}
			}
		},
		setCookie: function (cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		},

		decisionMountModal() {
			if (onboardingService.isCompletedAll() || !onboardingService.hasOnboarding() || onboardingService.isSkip()) {
				this.isMountModal = true;
			} else {
				this.isMountModal = false;
			}
		},
		checkUserDeactivated() {
			if (this.$auth.check()) {
				authService.getUser().then((userInfo) => {

					if (userInfo.active == -1) {
            this.$store.commit("authUser/setPopupAccountDeActive", true);
						this.$auth.logout({
							makeRequest: true,
							params: {},
							success: function () {
                this.$root.$emit("logout");
								// zendeskService.cancelAuthenticate();
							},
							error: function () {
							},
							redirect: '/login',
						}).catch((e) => {
							Promise.reject(e)
						});
					} else {
            this.$store.commit("authUser/setPopupAccountDeActive", false);

					}
				}).catch((e) => {
					Promise.reject(e)
				});
			}
		},

		// find offer start & find offer end
		trackingCodeFindOffer(type) {
			const cookieFindOffer = Cookies.get('time_find_offer');
			if (type === 'start') {
				if (!cookieFindOffer) {
					this.setCookie('time_find_offer', '30min', 30 / 1440);
					gtag("event", "find_offer_start");
				}
			} else {
				if (cookieFindOffer) {
					gtag("event", "find_offer_end");
					Cookies.remove('time_find_offer');
				}
			}
		},
		/**
		 * The veeValidate library not support change locale after we updated it
		 * Need to query the list inputs have attach veeValidate and trigger focus, blur event to change message locale
		 */
		refocusAllVsInputAfterChangeLocalize() {
			const inputs = document.querySelectorAll("input.vs-inputx");

			if (inputs.length) {
				inputs.forEach((input) => {
					let veeValidateMsg = null;

					try {
						veeValidateMsg = input.parentElement
							.parentElement
							.querySelector(".span-text-validation-danger")
							.querySelector(".span-text-validation")
					} catch (e) {
					}

					if (input.value || (veeValidateMsg && veeValidateMsg.textContent)) {
						setTimeout(() => {
							input.focus({
								preventScroll: true,
							});
							input.blur();
						}, 0);
					}
				});
			}
		},
		removeCookieTrackingCode() {
			setTimeout(() => {
				if (!Cookies.get("time_sign_up")) {
					Cookies.remove("time_sign_up");
					gtag("event", "sign_up_end");
				}
				if (!Cookies.get("time_find_offer")) {
					Cookies.remove("time_find_offer");
					gtag("event", "find_offer_end");
				}
				if (!Cookies.get("time_click_offer")) {
					Cookies.remove("time_click_offer");
					gtag("event", "click_offer_end");
				}

				if (!Cookies.get("time_create_link")) {
					Cookies.remove("time_create_link");
					gtag("event", "create_link_end");
				}
			}, 30 * 60 * 1000);
		},

		getStepNumberBubbleChat() {
			return this.UI.isMobile ? 8 : 7;
		},
	},

	mounted() {
    Vue.prototype.$bus.$on('check-ekyc-status', this.handleCheckEkycStatus);

    // this.fetchEkycStatus();
		this.toggleClassInBody(themeConfig.theme)
		this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)
		this.trackingPubRegister();
		this.decisionMountModal();

		// External script execution
		// Set attribute lang on html for current language of user
		const language = localStorage.getItem("language") || "vi";
		document.documentElement.setAttribute("lang", language);

		this.removeCookieTrackingCode();
		this.$root.$on("updateI18n", this.refocusAllVsInputAfterChangeLocalize);
    this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
      }
      next();
    });

	},

	async created() {
		window.addEventListener('resize', this.handleWindowResize);
		window.addEventListener('scroll', this.handleScroll);
    this.$root.$on("logout", this.handleCheckEkycStatus);
	},

  beforeDestroy() {
    // this.stopEkycInterval();
  },

	destroyed() {
		window.removeEventListener('resize', this.handleWindowResize);
		window.removeEventListener('scroll', this.handleScroll);
		this.$root.$off("updateI18n", this.refocusAllVsInputAfterChangeLocalize);
	},
}

</script>
<style lang="scss">
.bubble-chat-position {
	&.zendesk {
		height: 70px;
		width: 70px;
		bottom: 13px;
		right: 0;
	}

	&.messenger {
		height: 60px;
		width: 60px;
		bottom: 40px;
		right: 13px;
	}

	background: none;
	display: block;
	margin: 0px 12px;
	overflow: visible;
	padding: 0px;
	position: fixed;
	top: auto;
	z-index: 9999;
}
.required-label label::after {
  content: ' *';
  color: #EA5455;
  ;
}
</style>



// WEBPACK FOOTER //
// src/App.vue